export const FIELD_NAME = 'name';
export const FIELD_EMAIL = 'email';
export const FIELD_PHONE = 'phone';
export const FIELD_DESCRIPTION = 'description';
export const FIELD_ROLE = 'role';
export const FIELD_ALL = 'all';
export const MIN_FIELD_LENGTH = 1;
